module.exports = __webpack_public_path__ + "static/coupon-list-47a50ade9b9aa8376963b892f43466b4.png";